// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAxLxnNdFoQIfzlQQwCVZhd7lbJdA6p7K8",
  authDomain: "glizmed-ead88.firebaseapp.com",
  projectId: "glizmed-ead88",
  storageBucket: "glizmed-ead88.appspot.com",
  messagingSenderId: "220549054566",
  appId: "1:220549054566:web:8c8c360601191a93c06da7",
  measurementId: "G-HGXEJ7RBQ6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const authentication = getAuth(app);
